<app-shared-dialog
  [title]="
    (type === 'blacklist'
      ? 'agent.single_agent.catalogs.blacklist_title'
      : 'agent.single_agent.catalogs.whitelist_title'
    ) | translate
  "
  [options]="{
    titleIcon: type === 'blacklist' ? 'block-cc' : 'thumb-up-cc',
    titleIconColor: type === 'blacklist' ? 'danger' : 'primary',
    confirmText: 'common.update' | translate,
    confirmIcon: 'arrow-right',
    confirmIconPosition: 'end',
    cancelText: 'common.cancel' | translate,
    cancelButtonStyle: 'danger-btn',
    size: 'medium'
  }"
  (confirm)="save()"
  (cancel)="cancel()"
>
  <div class="description">
    {{ (type === 'blacklist'
      ? 'agent.single_agent.catalogs.blacklisted_desc'
      : 'agent.single_agent.catalogs.whitelisted_desc'
    ) | translate }}
  </div>
  <div>
    <span class="label">{{ "brands.brands" | translate }}</span>
    <mat-chip-list #brandChipList>
      <mat-chip
        *ngFor="let brand of selectedBrands"
        [selectable]="true"
        [removable]="true"
        (removed)="removeBrand(brand)"
        class="brand"
      >
        {{ brand.name }}
        <mat-icon matChipRemove>close</mat-icon>
      </mat-chip>
      <input
        *ngIf="selectedBrands.length != brands.length"
        name="brand"
        placeholder="{{ 'agent.details.select_placeholder' | translate }}"
        #brandInput
        [formControl]="brandControl"
        [matAutocomplete]="brandAuto"
        [matChipInputFor]="brandChipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="false"
        (matChipInputTokenEnd)="addBrandFromInput($event)"
      />
    </mat-chip-list>
    <mat-autocomplete
      #brandAuto="matAutocomplete"
      (optionSelected)="selectBrand($event.option.value)"
    >
      <mat-option *ngFor="let brand of filteredBrands | async" [value]="brand">
        {{ brand.name }}
      </mat-option>
    </mat-autocomplete>
  </div>
  <div>
    <span class="label">{{ "Labels.labels" | translate }}</span>
    <mat-chip-list #labelChipList>
      <mat-chip
        *ngFor="let label of selectedLabels"
        [selectable]="true"
        [removable]="true"
        (removed)="removeLabel(label)"
        class="label"
      >
        {{ label.name }}
        <mat-icon matChipRemove>close</mat-icon>
      </mat-chip>
      <input
        *ngIf="selectedLabels.length != labels.length"
        name="label"
        placeholder="{{ 'agent.details.select_placeholder' | translate }}"
        #labelInput
        [formControl]="labelControl"
        [matAutocomplete]="labelAuto"
        [matChipInputFor]="labelChipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="false"
        (matChipInputTokenEnd)="addLabelFromInput($event)"
      />
      <span *ngIf="labels.length === 0">
        {{ 'agent.single_agent.catalogs.no_data' | translate }}
      </span>
    </mat-chip-list>
    <mat-autocomplete
      #labelAuto="matAutocomplete"
      (optionSelected)="selectLabel($event.option.value)"
    >
      <mat-option *ngFor="let label of filteredLabels | async" [value]="label">
        {{ label.name }}
      </mat-option>
    </mat-autocomplete>
  </div>
  <div>
    <span class="label">{{ "Categories.categories" | translate }}</span>
    <mat-chip-list #categoryChipList>
      <mat-chip
        *ngFor="let category of selectedCategories"
        [selectable]="true"
        [removable]="true"
        (removed)="removeCategory(category)"
        class="category"
      >
        {{ category.name }}
        <mat-icon matChipRemove>close</mat-icon>
      </mat-chip>
      <input
        *ngIf="selectedCategories.length != categories.length"
        name="category"
        placeholder="{{ 'agent.details.select_placeholder' | translate }}"
        #categoryInput
        [formControl]="categoryControl"
        [matAutocomplete]="categoryAuto"
        [matChipInputFor]="categoryChipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="false"
        (matChipInputTokenEnd)="addCategoryFromInput($event)"
      />
      <span *ngIf="categories.length === 0">
        no data
      </span>
    </mat-chip-list>
    <mat-autocomplete
      #categoryAuto="matAutocomplete"
      (optionSelected)="selectCategory($event.option.value)"
    >
      <mat-option *ngFor="let category of filteredCategories | async" [value]="category">
        {{ category.name }}
      </mat-option>
    </mat-autocomplete>
  </div>
</app-shared-dialog>
